import { gql } from "@apollo/client";

export const CREATE_JOB_TITLE = gql`
  mutation CreateJobTitleMutation($input: CreateJobTitleInput!) {
    createJobTitle(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_JOB_TITLE = gql`
  mutation UpdateJobTitleMutation($id: Int!, $input: UpdateJobTitleInput!) {
    updateJobTitle(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_JOB_TITLE = gql`
  mutation RemoveJobTitleMutation($id: Int!) {
    removeJobTitle(id: $id) {
      ok
      error
    }
  }
`;

export const JOB_TITLE = gql`
  query JobTitleQuery($id: Int!) {
    jobTitle(id: $id) {
      ok
      error
      result {
        id
        name
      }
    }
  }
`;

export const JOB_TITLES = gql`
  query JobTitlesQuery($where: JobTitlesFiltersInput!) {
    jobTitles(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
      }
    }
  }
`;
